import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { DishComponent } from '../../../apiTypes';
import EditModal from '../../../components/EditModal';
import FormComponentsTable, { FormComponentsTableProps } from '../../../components/forms/FormComponentsTable2';
import { t } from '../../../constants/translations';
import { useCafe } from '../../../contexts/cafe.context';
import { useLocale } from '../../../contexts/locale.context';
import EditStore from '../../Stores/EditStore';

type Props = {
  open: boolean;
  defaultComponents: DishComponent[];
  price: number;
  onClose: () => void;
  onSubmit: (components: DishComponent[]) => void;
  requiredComponents?: DishComponent[];
  canBeNegative?: boolean;
};

type FormType = {
  components: DishComponent[];
};

const EditCostsOfProducts = ({
  defaultComponents,
  requiredComponents = [],
  price,
  open,
  canBeNegative,
  onSubmit,
  onClose,
}: Props) => {
  const { lang } = useLocale();
  const { ingredients } = useCafe();
  const [openAddStore, setOpenAddStore] = useState(false);

  const form = useForm<FormType>({
    mode: 'onChange',
    defaultValues: {
      components: defaultComponents,
    },
  });

  const handleClose = () => {
    onClose();
    form.reset();
  };

  const saveChanges = (values: FormType) => {
    onSubmit(values.components);

    handleClose();
  };

  return (
    <EditModal<FormType>
      title={t.costs_of_production[lang]}
      open={open}
      onClose={handleClose}
      submitButton={t.save_changes[lang]}
      onSubmit={saveChanges}
      form={form}
      size="md"
    >
      <FormComponentsTable
        form={form as unknown as FormComponentsTableProps['form']}
        options={ingredients}
        shouldSelectStore
        shouldShowCosts
        handleAddStore={() => setOpenAddStore(true)}
        disablePackingInit
        price={price}
        requiredComponents={requiredComponents}
        canBeNegative={canBeNegative}
      />
      {openAddStore && <EditStore open onClose={() => setOpenAddStore(false)} />}
    </EditModal>
  );
};

export default EditCostsOfProducts;
